import {
    ADD_PAPER_TO_UNASSIGNED,
    LOAD_PAPERS,
    REMOVE_PAPER_FROM_UNASSIGNED,
    SET_ARE_PAPERS_LOADED
} from "../actionTypes";

const initialState = {
    byIds: {},                  // Object like {<paper_id>: <paper object>}
    arePapersLoaded: false,     // Indicates whether papers have been fetched
};

export default function (state = initialState, action) {
    switch (action.type) {
        /* Load a list of papers, used once to fetch sessions from API */
        case LOAD_PAPERS: {
            const {papers} = action.payload;
            const byIds = {};
            for (const paper of papers) byIds[paper.id] = paper;
            return {
                ...state,
                byIds,
                arePapersLoaded: true
            };
        }
        /* Removes paper from the list of unassigned papers */
        case REMOVE_PAPER_FROM_UNASSIGNED: {
            const {paperId} = action.payload;
            let {[paperId]: paper, ...byIds} = state.byIds;
            return {
                ...state,
                byIds
            }
        }
        /* Adds paper to the list of unassigned papers */
        case ADD_PAPER_TO_UNASSIGNED: {
            const {paper} = action.payload;
            return {
                ...state,
                byIds: {
                    ...state.byIds,
                    [paper.id]: {
                        ...paper,
                        position: null,
                        session_id: null,
                    }
                }
            }
        }
        /* Set value for arePapersLoaded */
        case SET_ARE_PAPERS_LOADED: {
            const {value} = action.payload;
            return {
                ...state,
                arePapersLoaded: value
            }
        }
        default:
            return state;
    }
}
